<template>
  <div>
    <Header
      :headerTitle="$t('m.historyInvoicing.title')"
      :hasBackBtn="true"
      :rightIconSrc="require('../../assets/img/dianhua.png')"
      :onRightBtnClick="call"
      :iconShow="true"
    ></Header>
    <div style="border-top:1px solid #efefef;">
      <section
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="200"
      >
        <form v-if="resultList!=''">
          <div
            class="headerInfo items"
            v-for="(item,index) in resultList"
            :key="index"
            @click="invoicingInfo(item.invoice.id)"
          >
            <h5>
              <h6>{{item.invoice.createDate}}</h6>
              <span v-if="item.invoice.status==2" style="margin-top: 5px;">
                {{$t('m.historyInvoicing.statusStay')}}&nbsp;&nbsp;
                <img src="../../assets/img/zhankai.png">
              </span>
              <span v-if="item.invoice.status==1" style="margin-top: 5px;">
                {{$t('m.historyInvoicing.statusStop')}}&nbsp;&nbsp;
                <img src="../../assets/img/zhankai.png">
              </span>
            </h5>
            <p>{{$t('m.historyInvoicing.invoiceType')}}</p>
            <p>
              {{item.invoice.contents}}&nbsp;
              <span>
                {{item.invoice.amount==null?'&nbsp;':item.invoice.amount}}
                <i>{{$t('m.historyInvoicing.CNY')}}</i>
              </span>
            </p>
          </div>
        </form>
        <div v-if="resultList==''">{{$t('m.historyInvoicing.dataNull')}}</div>
      </section>
    </div>
    <b-modal
      ref="myModalRef"
      id="messageBox"
      centered
       :ok-title="$t('m.phone.call')"
      :title="$t('m.phone.serviceTitle')"
      :cancel-title="$t('m.phone.cancel')"
      @ok="handleOk"
    >{{phone}}</b-modal>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { invoiceList } from "../../api/invoice.js";
export default {
  name: "invoicingList",
  data() {
    return {
      resultList: [], //数据
      phone: "400-115-0606", //手机号
      page: 1,
      pageSize: 10,
      busy: false,
      total: 0,
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    //页面加载的数据
    loadOrderList: function() {
      let req = { page: this.page, pageSize: this.pageSize };
      invoiceList(req).then(
        response => {
          if (response.data.status == 200) {
            response.data.result.forEach(d => {
              this.resultList.push(d);
            });
            this.total = response.data.total;
            this.busy = false;
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    },
    //判断分页数码
    loadMore() {
      this.busy = true;
      let pages = Math.ceil(this.total / this.pageSize);
      if (this.page < pages) {
        this.page++;
        this.invoiceList();
      } else {
        this.busy = false;
      }
    },
    //进入发票详情操作
    invoicingInfo: function(id) {
      this.$router.push("/invoiceDetails/" + id);
    },
    call() {
      this.$refs.myModalRef.show();
    },
    handleOk: function() {
      window.location.href = "tel:" + this.phone;
    }
  },
  //页面加载
  created() {
    this.loadOrderList();
  }
};
</script>

<style scoped>
section .items h5 {
  text-align: left;
  margin-bottom: 0px;
}
section .items h6 {
  display: inline-block;
  font-weight: bold;
  color: #666;
  font-size: 14px;
}
section .items {
  margin-top: 10px;
  border-bottom: 8px solid #e9e9e9;
  border-top: 0;
  padding: 0 10px;
  padding-bottom: 10px;
}
section .items:last-child {
  border-bottom: 1px solid #e9e9e9;
}
section .items h5 span {
  display: inline-block;
  font-size: 13px;
  float: right;
}
section .items h5 span {
  color: #868585;
}
section .items h5 span img {
  padding-bottom: 4px;
}
section .items p {
  text-align: left;
  margin-right: 5px;
  font-size: 13px;
  color: #5c5c5c;
}
section .items p i {
  font-style: normal;
  font-size: 14px;
}
section .items p span {
  float: right;
  font-size: 19px;
  color: black;
}
</style>




